exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_topMargin__t0_A5{margin-top:1rem;width:100%}.style_title__1j5K0{color:rgba(0,0,0,.3);font-size:.75rem;font-weight:400;margin-bottom:.25rem}.style_checkboxNote__1BltZ{margin-left:40px}.style_message__10cC8{font-size:.75rem}.style_message__10cC8 hr{border-width:2px;margin-bottom-width:.25rem}", ""]);

// exports
exports.locals = {
	"topMargin": "style_topMargin__t0_A5",
	"title": "style_title__1j5K0",
	"checkboxNote": "style_checkboxNote__1BltZ",
	"message": "style_message__10cC8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/Checkbox/style.less
// module id = 1526
// module chunks = 8